module.exports = {};


//////////////////
// WEBPACK FOOTER
// /opt/mybespokeroom/shared/~/core-js/modules/_iterators.js
// module id = 56
// module chunks = 2 3 4 5 6 7 8 9 10 11 12